import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getDeviceStatus } from '../../utilities/getDeviceStatus';
import Loader from '../shared/loader';
import arrayUtilities from '../../utilities/arrayUtilities';
import { StatusBar } from '../shared/statusBar';

export const DeviceStatusWidget = ({ handleRefreshClick, viewAllUrl, orderedDevices, isLoading, deviceType, warningThreshold, dangerThreshold }) => {
    const [deviceStatuses, setDeviceStatuses] = useState(null)
    useEffect(() => {
        setDeviceStatuses(orderedDevices?.reduce((acc, curr) => {
            const { status } = getDeviceStatus(curr, deviceType, warningThreshold, dangerThreshold);
            if (status === 0) {
                acc["unknown"]++
            } else if (status === 1) {
                acc["danger"]++
            } else if (status === 2) {
                acc["warning"]++
            } else if (status === 3) {
                acc["success"]++
            }
            return acc
        }, { success: 0, warning: 0, danger: 0, unknown: 0 })
        )
    }, [orderedDevices])

    return (
        <div className="card status-widget">
            <div className="card-header">
                <div className="row align-items-center justify-content-between px-2">
                    <h5 className="fs-0 mb-0 text-nowrap py-2 py-xl-0">{ deviceType } Status</h5>
                    <div className="d-flex">
                        <button
                            onClick={ () => handleRefreshClick() }
                            className="btn btn-none m-0 p-0"
                        >
                            <i className="fas fa-sync d-flex align-items-center ml-2"></i>
                        </button>
                        <Link to={ viewAllUrl }>
                            <button className="btn btn-falcon-default btn-sm ml-2 d-flex align-items-center">
                                <span>View All<i className="ml-2 fas fa-chevron-right"></i></span>
                            </button>
                        </Link>
                    </div>
                </div>
            </div>
            <div className='stacked-chart'>
                {
                    isLoading
                        ? <span className='tiny-loader'><Loader /></span>
                            : arrayUtilities.isNullOrEmpty(orderedDevices) || !deviceStatuses
                            ? <div className='d-flex justify-content-center'><i className='fas fa-question fa-3x' style={ { color: "#c9c9c9" } }></i></div>
                            : <StatusBar counts={ deviceStatuses } />
                }
            </div>
        </div>
    )
}
